import React, { useState, useEffect } from "react";
import "./Crawler Dashboard/../../style/Crawler.css";
import noDataImage from "./Crawler Dashboard/../../style/nodatafound.png";
import nodata from "./../../../../images/nodata2.png";
import "../../../../styles/NewsCardsUpdated.css";
import fallbackimg from "./../../../../images/Image-not-found.png";

const truncateContent = (content, wordLimit) => {
  const words = content && content.split(" ");
  return words && words.length > wordLimit
    ? words.slice(0, wordLimit).join(" ") + "..."
    : content;
};

const NewsCardSkeleton = ({ isHero = false }) => (
  <div className="nc-skeleton-card">
    <div
      className={`nc-skeleton-image ${isHero ? "nc-skeleton-hero-image" : ""}`}
    />
    <div className="nc-skeleton-content">
      <div className="nc-skeleton-title" />
      <div className="nc-skeleton-text" />
      <div className="nc-skeleton-text" />
      <div className="nc-skeleton-text" />
      <div className="nc-skeleton-btn" />
    </div>
  </div>
);

const NewsCardRegular = ({ data }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const displayContent = isExpanded
    ? data.content
    : truncateContent(data.content, 80);

  return (
    <div className="nc-regular-card">
      <img
        src={data?.imageLink ? data.imageLink : fallbackimg}
        className="nc-hero-image"
        alt={data?.title || "No Data"}
        referrerPolicy="no-referrer"
        loading="lazy"
      />
      <div className="nc-regular-content">
        <h5 className="nc-regular-title">{data.title}</h5>
        <p className="nc-regular-text">{displayContent}</p>
        {data.content && data.content.split(" ").length > 20 && (
          <button className="nc-toggle-btn" onClick={handleToggleExpand}>
            {isExpanded ? "Read Less" : "Read More"}
          </button>
        )}
        <div className="nc-meta-info">
          <div className="nc-meta-item">
            <span className="nc-meta-label">Author:</span>
            <span className="nc-meta-value">{data.author}</span>
          </div>
          <div className="nc-meta-item">
            <span className="nc-meta-label">Publisher:</span>
            <span className="nc-meta-value">{data.newsChannel}</span>
          </div>
          <div className="nc-meta-item">
            <span className="nc-meta-label">Published:</span>
            <span className="nc-meta-value">
              {new Intl.DateTimeFormat("en-GB", {
                day: "2-digit",
                month: "short",
                year: "2-digit",
                timeZone: "UTC",
              }).format(new Date(data.datePublished))}
              , 
              {new Intl.DateTimeFormat("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
                timeZone: "UTC",
              }).format(new Date(data.datePublished))}
            </span>
          </div>
        </div>
        <div className="nc-sentiment">
          <div className="nc-sentiment-title">Sentiment Analysis</div>
          <div className="nc-sentiment-values">
            {data.sentimentAccuracy
              ? `Positive: ${data.sentimentAccuracy.positive}%, Negative: ${data.sentimentAccuracy.negative}%`
              : "No sentiment data available"}
          </div>
        </div>
        <button
          className="nc-visit-btn"
          onClick={() => window.open(data.link, "_blank")}
        >
          Visit Article
        </button>
      </div>
    </div>
  );
};

function NewsCards({
  analysisData = [],
  currentPage,
  setCurrentPage,
  isLoading,
  toggleNewsView,
  totalPageCount,
}) {
  const itemsPerPage = 15;

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPageCount) return;
    setCurrentPage(newPage);
    toggleNewsView(newPage); // This will trigger API fetch
  };

  return (
    <div className="nc-container">
      <div className="nc-grid-section">
        {isLoading ? (
          Array.from({ length: itemsPerPage }).map((_, index) => (
            <NewsCardSkeleton key={index} />
          ))
        ) : analysisData.length > 0 ? (
          analysisData.map((data, index) => (
            <NewsCardRegular key={index} data={data} />
          ))
        ) : (
          <div className="nc-no-data">
            <img
              src={nodata}
              className="nc-no-data-image"
              alt="No data found"
            />
            <div className="nc-no-data-text">No news articles found</div>
          </div>
        )}
      </div>

      {analysisData.length > 0 && (
        <div className="nc-pagination">
          <button
            className="nc-pagination-btn"
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            First
          </button>
          <button
            className="nc-pagination-btn"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span className="nc-pagination-info">
            Page {currentPage} of {totalPageCount}
          </span>
          <button
            className="nc-pagination-btn"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPageCount}
          >
            Next
          </button>
          <button
            className="nc-pagination-btn"
            onClick={() => handlePageChange(totalPageCount)}
            disabled={currentPage === totalPageCount}
          >
            Last
          </button>
        </div>
      )}
    </div>
  );
}

export default NewsCards;